import { fork } from 'redux-saga/effects';
import * as authSaga from './auth.saga';
import * as assignmentsSaga from './assignments.saga';
import * as assignmentFilesSaga from './assignment_files.saga';
import * as dropboxesSaga from  './dropboxes.saga';
import * as filesSaga from './files.saga';
import * as logsSaga from './logs.saga';
import * as membershipsSaga from './memberships.saga';
import * as rolesSaga from './roles.saga';
import * as runscriptSaga from './runscript.saga';
import * as semestersSaga from './semesters.saga';
import * as submissionsSaga from './submissions.saga';
import * as subscriptionsSaga from './subscriptions.saga';
import * as usersSaga from './users.saga';

export default function* rootSaga() {
  yield [
    fork(authSaga.watchLogoutRequested),
    fork(authSaga.watchRefreshToken),
    fork(authSaga.watchTokenExpired),


    fork(assignmentsSaga.watchRequestAssignments),
    fork(assignmentsSaga.watchRequestAssignmentsSucceeded),
    fork(assignmentsSaga.watchRequestAssignmentsFailed),

    fork(assignmentsSaga.watchRequestDropboxAssignment),
    fork(assignmentsSaga.watchRequestDropboxAssignmentSucceeded),
    fork(assignmentsSaga.watchRequestDropboxAssignmentFailed),

    fork(assignmentsSaga.watchRequestCreateAssignment),
    fork(assignmentsSaga.watchRequestCreateAssignmentSucceeded),
    fork(assignmentsSaga.watchRequestCreateAssignmentFailed),

    fork(assignmentsSaga.watchRequestUpdateAssignment),
    fork(assignmentsSaga.watchRequestUpdateAssignmentSucceeded),
    fork(assignmentsSaga.watchRequestUpdateAssignmentFailed),

    fork(assignmentsSaga.watchRequestDeleteAssignment),
    fork(assignmentsSaga.watchRequestDeleteAssignmentSucceeded),
    fork(assignmentsSaga.watchRequestDeleteAssignmentFailed),

    fork(assignmentsSaga.watchRequestCopyAssignment),
    fork(assignmentsSaga.watchRequestCopyAssignmentSucceeded),
    fork(assignmentsSaga.watchRequestCopyAssignmentFailed),

    fork(assignmentsSaga.watchRequestCopyAssignments),
    fork(assignmentsSaga.watchRequestCopyAssignmentsSucceeded),
    fork(assignmentsSaga.watchRequestCopyAssignmentsFailed),


    fork(assignmentFilesSaga.watchRequestAssignmentFileUpload),
    fork(assignmentFilesSaga.watchRequestAssignmentFileUploadSucceeded),
    fork(assignmentFilesSaga.watchRequestAssignmentFileUploadFailed),
    fork(assignmentFilesSaga.watchRequestAssignmentFileUploadBadRequest),

    fork(assignmentFilesSaga.watchRequestAssignmentFileDelete),
    fork(assignmentFilesSaga.watchRequestAssignmentFileDeleteSucceeded),
    fork(assignmentFilesSaga.watchRequestAssignmentFileDeleteFailed),

    fork(assignmentFilesSaga.watchRequestAssignmentFileDownload),
    fork(assignmentFilesSaga.watchRequestAssignmentFileDownloadSucceeded),
    fork(assignmentFilesSaga.watchRequestAssignmentFileDownloadFailed),


    fork(dropboxesSaga.watchRequestDropboxes),
    fork(dropboxesSaga.watchRequestDropboxesSucceeded),
    fork(dropboxesSaga.watchRequestDropboxesFailed),

    fork(dropboxesSaga.watchRequestUpdateDropboxShowIndex),
    fork(dropboxesSaga.watchRequestUpdateDropboxShowIndexSucceeded),
    fork(dropboxesSaga.watchRequestUpdateDropboxShowIndexFailed),


    fork(filesSaga.watchRequestFileUpload),
    fork(filesSaga.watchRequestFileUploadSucceeded),
    fork(filesSaga.watchRequestFileUploadFailed),
    fork(filesSaga.watchRequestFileUploadBadRequest),

    fork(filesSaga.watchRequestFileDelete),
    fork(filesSaga.watchRequestFileDeleteSucceeded),
    fork(filesSaga.watchRequestFileDeleteFailed),

    fork(filesSaga.watchRequestFileDownload),
    fork(filesSaga.watchRequestFileDownloadSucceeded),
    fork(filesSaga.watchRequestFileDownloadFailed),


    fork(logsSaga.watchRequestLogs),
    fork(logsSaga.watchRequestLogsSucceeded),
    fork(logsSaga.watchRequestLogsFailed),


    fork(membershipsSaga.watchRequestDropboxUserMemberships),
    fork(membershipsSaga.watchRequestDropboxUserMembershipsSucceeded),
    fork(membershipsSaga.watchRequestDropboxUserMembershipsFailed),

    fork(membershipsSaga.watchRequestAssignmentMemberships),
    fork(membershipsSaga.watchRequestAssignmentMembershipsSucceeded),
    fork(membershipsSaga.watchRequestAssignmentMembershipsFailed),

    fork(membershipsSaga.watchRequestSubmissionMemberships),
    fork(membershipsSaga.watchRequestSubmissionMembershipsSucceeded),
    fork(membershipsSaga.watchRequestSubmissionMembershipsFailed),

    fork(membershipsSaga.watchRequestDeclineSubmissionMembership),
    fork(membershipsSaga.watchRequestDeclineSubmissionMembershipSucceeded),
    fork(membershipsSaga.watchRequestDeclineSubmissionMembershipFailed),

    fork(membershipsSaga.watchRequestDeleteSubmissionMembership),
    fork(membershipsSaga.watchRequestDeleteSubmissionMembershipSucceeded),
    fork(membershipsSaga.watchRequestDeleteSubmissionMembershipFailed),


    fork(rolesSaga.watchRequestDropboxRoles),
    fork(rolesSaga.watchRequestDropboxRolesSucceeded),
    fork(rolesSaga.watchRequestDropboxRolesFailed),

    fork(rolesSaga.watchRequestRolesSelf),
    fork(rolesSaga.watchRequestRolesSelfSucceeded),
    fork(rolesSaga.watchRequestRolesSelfFailed),


    fork(runscriptSaga.watchRequestTriggerRunscript),
    fork(runscriptSaga.watchRequestTriggerRunscriptSucceeded),
    fork(runscriptSaga.watchRequestTriggerRunscriptFailed),

    fork(runscriptSaga.watchRequestRunscriptOutput),
    fork(runscriptSaga.watchRequestRunscriptOutputSucceeded),
    fork(runscriptSaga.watchRequestRunscriptOutputFailed),

    fork(runscriptSaga.watchRequestLatestRunscripts),
    fork(runscriptSaga.watchRequestLatestRunscriptsSucceeded),
    fork(runscriptSaga.watchRequestLatestRunscriptsFailed),

    fork(semestersSaga.watchRequestSemesters),
    fork(semestersSaga.watchRequestSemestersSucceeded),
    fork(semestersSaga.watchRequestSemestersFailed),

    fork(subscriptionsSaga.watchRequestUpdateSubscriptions),
    fork(subscriptionsSaga.watchRequestUpdateSubscriptionSucceeded),
    fork(subscriptionsSaga.watchRequestUpdateSubscriptionsFailed),


    fork(submissionsSaga.watchRequestAssignmentSubmissions),
    fork(submissionsSaga.watchRequestAssignmentSubmissionsSucceeded),
    fork(submissionsSaga.watchRequestAssignmentSubmissionsFailed),

    fork(submissionsSaga.watchRequestDropboxUserSubmissions),
    fork(submissionsSaga.watchRequestDropboxUserSubmissionsSucceeded),
    fork(submissionsSaga.watchRequestDropboxUserSubmissionsFailed),

    fork(submissionsSaga.watchRequestUpdateSubmission),
    fork(submissionsSaga.watchRequestUpdateSubmissionSucceeded),
    fork(submissionsSaga.watchRequestUpdateSubmissionFailed),

    fork(submissionsSaga.watchRequestUpdateNotDoneSubmission),
    fork(submissionsSaga.watchRequestUpdateNotDoneSubmissionSucceeded),
    fork(submissionsSaga.watchRequestUpdateNotDoneSubmissionFailed),

    fork(submissionsSaga.watchRequestConfirmSubmission),
    fork(submissionsSaga.watchRequestConfirmSubmissionSucceeded),
    fork(submissionsSaga.watchRequestConfirmSubmissionFailed),

    fork(submissionsSaga.watchRequestCreateSubmission),
    fork(submissionsSaga.watchRequestCreateSubmissionSucceeded),
    fork(submissionsSaga.watchRequestCreateSubmissionFailed),

    fork(submissionsSaga.watchRequestDropboxAssignmentSubmission),
    fork(submissionsSaga.watchRequestDropboxAssignmentSubmissionSucceeded),
    fork(submissionsSaga.watchRequestDropboxAssignmentSubmissionFailed),


    fork(usersSaga.watchRequestDropboxUsers),
    fork(usersSaga.watchRequestDropboxUsersSucceeded),
    fork(usersSaga.watchRequestDropboxUsersFailed)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/sagas/index.js
 **/